import React, { useState, useEffect } from "react";
import { DateRangeSelector } from "../../SysGuardCommonComp";
import { ENTRA } from "../../../../redux/constants/constants";
import { useSelector } from "react-redux";
import { SET_SYS_FROM_TIME_STAMP, SET_SYS_TO_TIME_STAMP } from "../../sysGuardConstants";

const TimeSelector = ({ type }) => {
  const globalFromTimeStamp = useSelector(
    (state) => state.SysGuardReducer.fromTimeStamp
  );
  const globalToTimeStamp = useSelector(
    (state) => state.SysGuardReducer.toTimeStamp
  );
  return (
    <div
      className={
        type === ENTRA
          ? "timeSelectorContainer"
          : "timeSelectorContainer workSpace"
      }
    >
      <DateRangeSelector
        fromTimeStamp={globalFromTimeStamp}
        toTimeStamp={globalToTimeStamp}
        fromAction={(payload) => ({ type: SET_SYS_FROM_TIME_STAMP, payload })}
        toAction={(payload) => ({ type: SET_SYS_TO_TIME_STAMP, payload })}
      />
    </div>
  );
};

export default TimeSelector;
